import { render, staticRenderFns } from "./GuestsDelete.vue?vue&type=template&id=855cc164&"
import script from "./GuestsDelete.vue?vue&type=script&lang=js&"
export * from "./GuestsDelete.vue?vue&type=script&lang=js&"
import style0 from "./GuestsDelete.vue?vue&type=style&index=0&id=855cc164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports